"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPPER_JS_POSITION_MAPPER = exports.MAX_HEIGHT_SMALL_VIEWPORT = exports.MAX_HEIGHT_LARGE_VIEWPORT = exports.MAX_WIDTH_SMALL_VIEWPORT = exports.MAX_WIDTH_LARGE_VIEWPORT = exports.CONTENT_PADDING = exports.ANIMATION_SLIDE_AMOUNT = exports.ANIMATION_DURATION = exports.ARROW_HORIZONTAL_OFFSET = exports.ARROW_WIDTH = exports.ARROW_HEIGHT = exports.MENU_CONTENT_ROLE = exports.POPOVER_CONTENT_ID = exports.PopoverDefaultProps = exports.PopoverControllerDefaultProps = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _interfaces = require("./interfaces");

var _POPPER_JS_POSITION_M;

var PopoverControllerDefaultProps = {
  position: _interfaces.PopoverPosition.BottomLeading,
  shouldFocusOnOpen: false,
  shouldCloseOnFocusLeave: true
};
exports.PopoverControllerDefaultProps = PopoverControllerDefaultProps;
var defaultTriggerButtonProps = {};
var PopoverDefaultProps = (0, _objectSpread2.default)({}, PopoverControllerDefaultProps, {
  triggerButtonProps: defaultTriggerButtonProps
});
exports.PopoverDefaultProps = PopoverDefaultProps;
var POPOVER_CONTENT_ID = 'stencil-popover-content';
exports.POPOVER_CONTENT_ID = POPOVER_CONTENT_ID;
var MENU_CONTENT_ROLE = 'menu';
exports.MENU_CONTENT_ROLE = MENU_CONTENT_ROLE;
var ARROW_HEIGHT = 8;
exports.ARROW_HEIGHT = ARROW_HEIGHT;
var ARROW_WIDTH = ARROW_HEIGHT * 2;
exports.ARROW_WIDTH = ARROW_WIDTH;
var ARROW_HORIZONTAL_OFFSET = 8;
exports.ARROW_HORIZONTAL_OFFSET = ARROW_HORIZONTAL_OFFSET;
var ANIMATION_DURATION = 200;
exports.ANIMATION_DURATION = ANIMATION_DURATION;
var ANIMATION_SLIDE_AMOUNT = 16;
exports.ANIMATION_SLIDE_AMOUNT = ANIMATION_SLIDE_AMOUNT;
var CONTENT_PADDING = 'S300';
exports.CONTENT_PADDING = CONTENT_PADDING;
var MAX_WIDTH_LARGE_VIEWPORT = '40vw';
exports.MAX_WIDTH_LARGE_VIEWPORT = MAX_WIDTH_LARGE_VIEWPORT;
var MAX_WIDTH_SMALL_VIEWPORT = 'calc(100vw - 32px)';
exports.MAX_WIDTH_SMALL_VIEWPORT = MAX_WIDTH_SMALL_VIEWPORT;
var MAX_HEIGHT_LARGE_VIEWPORT = '80vh';
exports.MAX_HEIGHT_LARGE_VIEWPORT = MAX_HEIGHT_LARGE_VIEWPORT;
var MAX_HEIGHT_SMALL_VIEWPORT = '60vh';
exports.MAX_HEIGHT_SMALL_VIEWPORT = MAX_HEIGHT_SMALL_VIEWPORT;
var POPPER_JS_POSITION_MAPPER = (_POPPER_JS_POSITION_M = {}, (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.TopLeading, 'top-start'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.TopCenter, 'top'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.TopTrailing, 'top-end'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.BottomLeading, 'bottom-start'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.BottomCenter, 'bottom'), (0, _defineProperty2.default)(_POPPER_JS_POSITION_M, _interfaces.PopoverPosition.BottomTrailing, 'bottom-end'), _POPPER_JS_POSITION_M);
exports.POPPER_JS_POSITION_MAPPER = POPPER_JS_POSITION_MAPPER;